import React from 'react';
import { FaDownload } from 'react-icons/fa';
import { download } from '../../scripts/dataTable';
import { paths } from '../../config/app-config';

const ExportButton = (props) => {
  const downloadFile = async() => {
    let downloadUrl = props.fullUrl || paths.downloadPath(props.from);
    downloadUrl = props.storeLanguage && props.storeCountry ?
                  `${downloadUrl}?locale=${props.storeLanguage}_${props.storeCountry}` :
                  downloadUrl;

    const { status, data, fileName } = await download(downloadUrl);
    if(status) { // download success
      downloadCSV(data, fileName)
    }
  }

  const downloadCSV = async (data, fileName) => {
    const csvData = new Blob(["\uFEFF" + data], { type: 'text/csv' }); // "\uFEFF" - BOM for utf-8
    const csvURL = URL.createObjectURL(csvData);
    const link = document.createElement('a');
    link.href = csvURL;
    link.download = `${fileName}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

  return (
    <div className={props.className}>
      <button className="pda-button-export" onClick={downloadFile}>
        <div className="pda-float-left"> {props.buttonText} </div>
        <div className="pda-float-right"> <FaDownload /> </div>
      </button>
    </div>
  )
}

export default ExportButton;
